import SwitchingCategoriesIcon from "../../../assets/Switching/switchingCategoriesIcon.svg";
import type { ProductGroup } from "../../../types";

export const gigabitEthernet: ProductGroup = {
  id: "gigabitEthernet",
  title: "productGroup.gigabitEthernet.title",
  icon: {
    src: SwitchingCategoriesIcon,
    width: 64,
    height: 40,
  },
};
